import React from 'react';
import { Button, ButtonProps } from './button.component';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { buildURI } from 'react-csv/lib/core';


export const DownloadCSVButton: React.VFC<ButtonProps & {
  filename: string;
  headers: { key: string; label: string }[];
  data: Record<string, unknown>[];
  onClick?: never;
  onSuccess?: () => void;
}> = ({ filename, headers, data, onSuccess, onClick: _onClick, ...props }) => {
  return (
    <Button
      onClick={async () => {
        const csvURL = buildURI(data, undefined, headers);
        const a = document.createElement('a');

        a.download = filename;
        a.href = csvURL;
        a.target = '_blank';
        a.click();
        onSuccess?.();
      }}
      {...props}
    />
  );
};
